import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <header className="backdrop-blur-lg border-b border-white/30 sticky top-0 z-50 bg-white/80 shadow-sm" data-testid="header">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center" data-testid="logo">
            <img src="/isk-logo.png" alt="ISK" className="h-10 w-auto" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-testid="desktop-nav">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-isk-text hover:text-isk-teal font-medium transition-colors"
              data-testid="nav-services"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('partnership')}
              className="text-isk-text hover:text-isk-teal font-medium transition-colors"
              data-testid="nav-partnership"
            >
              Partnership
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="text-isk-text hover:text-isk-teal font-medium transition-colors"
              data-testid="nav-case-studies"
            >
              Testimonies
            </button>
            <button 
              onClick={() => scrollToSection('roi')}
              className="text-isk-text hover:text-isk-teal font-medium transition-colors"
              data-testid="nav-roi"
            >
              ROI
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-isk-text hover:text-isk-teal font-medium transition-colors"
              data-testid="nav-faq"
            >
              FAQ
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-isk-text hover:text-isk-teal font-medium transition-colors"
              data-testid="nav-contact"
            >
              Contact
            </button>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center">
            <Button
              onClick={() => window.location.href = '/login'}
              variant="outline"
              className="border-2 border-isk-teal/30 text-isk-teal hover:bg-isk-teal hover:text-white rounded-full px-6 py-3 font-semibold transition-all"
              data-testid="cta-dashboard"
            >
              Login
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-white/50 transition-colors"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-4" data-testid="mobile-nav">
            <button 
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-4 py-2 text-isk-text hover:text-isk-teal font-medium transition-colors"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('partnership')}
              className="block w-full text-left px-4 py-2 text-isk-text hover:text-isk-teal font-medium transition-colors"
            >
              Partnership
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left px-4 py-2 text-isk-text hover:text-isk-teal font-medium transition-colors"
            >
              Testimonies
            </button>
            <button 
              onClick={() => scrollToSection('roi')}
              className="block w-full text-left px-4 py-2 text-isk-text hover:text-isk-teal font-medium transition-colors"
            >
              ROI
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left px-4 py-2 text-isk-text hover:text-isk-teal font-medium transition-colors"
            >
              FAQ
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-2 text-isk-text hover:text-isk-teal font-medium transition-colors"
            >
              Contact
            </button>
            <div className="px-4 pt-4 space-y-3 border-t border-isk-teal/20">
              <Button
                onClick={() => window.location.href = '/login'}
                variant="outline"
                className="w-full border-2 border-isk-teal/30 text-isk-teal hover:bg-isk-teal hover:text-white rounded-full px-6 py-3 font-semibold"
              >
                Login
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
